//随机生成字符串
export function randomNum(n) {
  let res = ""
  for ( let i=0; i<n; i++){
    res += Math.floor(Math.random()*10)
  }
  return res
}
